import { WebSocketLink } from '@apollo/client/link/ws';
import { getMainDefinition } from '@apollo/client/utilities';
import { setContext } from '@apollo/client/link/context';
import { ApolloClient, HttpLink, InMemoryCache, split } from '@apollo/client';
import { firebaseProvider } from './firebase';
import { authProvider } from './auth';
import { GRAPHQL_ENDPOINT, GRAPHQL_WS_ENDPOINT } from '../config';

// Create an http link:
const httpLink = new HttpLink({
  uri: GRAPHQL_ENDPOINT,
});

// Create a WebSocket link:
let wsLink;

if (process.browser) {
  wsLink = new WebSocketLink({
    uri: GRAPHQL_WS_ENDPOINT,
    options: {
      reconnect: true,
      lazy: true,
      connectionParams: async () => {
        if (firebaseProvider.getFirebaseCurrentUser()) {
          const token = await authProvider.getAuthHeaders();

          return {
            headers: {
              Authorization: token,
            },
          };
        }

        return {};
      },
    },
  });
}

const authLink = setContext(async (_, { headers }) => {
  if (firebaseProvider.getFirebaseCurrentUser()) {
    const token = await authProvider.getAuthHeaders();

    return {
      headers: {
        ...headers,
        Authorization: token,
        // eslint-disable-next-line no-use-before-define
        apolloClient,
      },
    };
  }

  return {
    headers,
  };
});

let link = authLink.concat(httpLink);

// Load subscription only in browser
if (process.browser) {
  link = split(
    // split based on operation type
    ({ query }) => {
      const definition = getMainDefinition(query);
      return definition.kind === 'OperationDefinition' && definition.operation === 'subscription';
    },
    wsLink,
    authLink.concat(httpLink),
  );
}

export const apolloClient = new ApolloClient({
  ssrMode: !process.browser,
  link,
  cache: new InMemoryCache(),
});
